// Plantillas por RUBRO: presets curados (no son datos por tenant) que arrancan una
// plantilla lista para un giro de negocio. Al elegir uno se crea una signage.plantilla
// real con estas escenas (jsonb) y el tema recomendado; luego se ajusta y se publica.
// Solo usan escenas dirigidas por datos (catálogo/carta/mensaje/qr) → funcionan de
// inmediato con el catálogo real del local, sin requerir medios subidos.
import { Coffee, Cpu, Pill, Shirt, ShoppingCart, UtensilsCrossed } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { Escena } from './player';

export interface RubroPreset {
  key: string;
  label: string;
  desc: string;
  Icon: LucideIcon;
  tema: 'calido' | 'frio' | 'oscuro';
  escenas: Escena[];
}

export const RUBROS: RubroPreset[] = [
  {
    key: 'farmacia', label: 'Farmacia', Icon: Pill, tema: 'frio',
    desc: 'Productos destacados, consejo de salud y compra en línea por QR.',
    escenas: [
      { tipo: 'catalogo', dur: 8, trans: 'fundido' },
      { tipo: 'mensaje', dur: 8, titulo: 'Tu salud, primero', texto: 'Consulta con nuestro farmacéutico', trans: 'zoom' },
      { tipo: 'qr', dur: 10, titulo: 'Pide en línea', trans: 'deslizar' },
    ],
  },
  {
    key: 'restaurante', label: 'Restaurante', Icon: UtensilsCrossed, tema: 'calido',
    desc: 'Menú a la carta, platos en grande y sugerencia del chef.',
    escenas: [
      { tipo: 'carta', dur: 18, titulo: 'Nuestra carta', trans: 'fundido' },
      { tipo: 'catalogo', dur: 8, trans: 'zoom' },
      { tipo: 'mensaje', dur: 7, titulo: 'Sugerencia del chef', texto: 'Pregunta por el plato del día', trans: 'deslizar' },
    ],
  },
  {
    key: 'moda', label: 'Moda / Retail', Icon: Shirt, tema: 'oscuro',
    desc: 'Vitrina premium de productos, nueva colección y compra en línea.',
    escenas: [
      { tipo: 'catalogo', dur: 8, trans: 'zoom' },
      { tipo: 'mensaje', dur: 7, titulo: 'Nueva colección', texto: 'Descúbrela en tienda', trans: 'fundido' },
      { tipo: 'qr', dur: 10, titulo: 'Compra en línea', trans: 'deslizar' },
    ],
  },
  {
    key: 'cafeteria', label: 'Cafetería / Panadería', Icon: Coffee, tema: 'calido',
    desc: 'Menú, productos recién hechos y mensaje de temporada.',
    escenas: [
      { tipo: 'carta', dur: 16, titulo: 'Menú', trans: 'fundido' },
      { tipo: 'catalogo', dur: 7, trans: 'zoom' },
      { tipo: 'mensaje', dur: 6, titulo: 'Recién hecho', texto: 'Café de especialidad todo el día', trans: 'fundido' },
    ],
  },
  {
    key: 'super', label: 'Supermercado / Minimarket', Icon: ShoppingCart, tema: 'frio',
    desc: 'Rotación rápida de productos, ofertas de la semana y destacados.',
    escenas: [
      { tipo: 'catalogo', dur: 7, trans: 'corte' },
      { tipo: 'mensaje', dur: 6, titulo: 'Ofertas de la semana', texto: 'Aprovéchalas hoy', trans: 'deslizar' },
      { tipo: 'carta', dur: 14, titulo: 'Destacados', trans: 'fundido' },
    ],
  },
  {
    key: 'tecnologia', label: 'Tecnología / Ferretería', Icon: Cpu, tema: 'oscuro',
    desc: 'Catálogo, asesoría experta y cotización en línea por QR.',
    escenas: [
      { tipo: 'catalogo', dur: 8, trans: 'zoom' },
      { tipo: 'mensaje', dur: 7, titulo: 'Asesoría experta', texto: 'Te ayudamos a elegir', trans: 'fundido' },
      { tipo: 'qr', dur: 10, titulo: 'Cotiza en línea', trans: 'deslizar' },
    ],
  },
];
